import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, toHandlers as _toHandlers, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c12f345")

_pushScopeId("data-v-4c12f345")
const _hoisted_1 = { class: "p-r fill df-col bg-white" }
const _hoisted_2 = {
  id: "hc_main_chart",
  class: "fill p-r flex-1 over-hidden"
}
const _hoisted_3 = {
  id: "ch_study_chart",
  class: "fill p-r",
  style: {"height":"110px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheResolutionArea = _resolveComponent("TheResolutionArea")
  const _component_Line = _resolveComponent("Line")
  const _component_TheTrend = _resolveComponent("TheTrend")
  const _component_ThePositionLines = _resolveComponent("ThePositionLines")
  const _component_ThePriceLabel = _resolveComponent("ThePriceLabel")
  const _component_TheCrosshair = _resolveComponent("TheCrosshair")
  const _component_TheDrawingDialog = _resolveComponent("TheDrawingDialog")
  const _component_TheGuide = _resolveComponent("TheGuide")
  const _component_TheStudyBar = _resolveComponent("TheStudyBar")
  const _component_TheHorizontalScan = _resolveComponent("TheHorizontalScan")
  const _component_Pic = _resolveComponent("Pic")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TheGuide, { class: "flex-1 df-col p-r" }, {
      default: _withId(({ feedback }) => [
        _createVNode(_component_TheResolutionArea, {
          onChange: _ctx.changeResolution,
          onDraw: type => _ctx.draw(type, feedback),
          onFullscreen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('fullscreen')))
        }, null, 8, ["onChange", "onDraw"]),
        _createVNode(_component_Line),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_TheTrend, { code: _ctx.code }, null, 8, ["code"]),
          _createVNode(_component_ThePositionLines, {
            code: _ctx.code,
            fy: _ctx.fy
          }, null, 8, ["code", "fy"]),
          _createVNode(_component_ThePriceLabel, {
            price: _ctx.price,
            position: _ctx.position
          }, null, 8, ["price", "position"]),
          _createVNode(_component_TheCrosshair, { crosshair: _ctx.crosshair }, null, 8, ["crosshair"]),
          _withDirectives(_createVNode(_component_TheDrawingDialog, _mergeProps(_ctx.drawingBindings, {
            onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modifyDrawing = false))
          }, _toHandlers(_ctx.drawingListeners)), null, 16), [
            [_vShow, _ctx.modifyDrawing]
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Line),
    _createVNode(_component_TheStudyBar, {
      studies: _ctx.overlayStudies,
      onChange: _ctx.changeOverlayStudy,
      selected: _ctx.defaultOverlayStudy
    }, null, 8, ["studies", "onChange", "selected"]),
    _createVNode(_component_Line),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_TheHorizontalScan, { crosshair: _ctx.crosshair }, null, 8, ["crosshair"])
    ]),
    _createVNode(_component_Line),
    _createVNode(_component_TheStudyBar, {
      studies: _ctx.panelStudies,
      onChange: _ctx.changePanelStudy
    }, null, 8, ["studies", "onChange"]),
    _createVNode(_component_Line),
    _createVNode(_component_Pic, {
      src: "to_right",
      id: "restore",
      width: "24",
      height: "24"
    })
  ]))
})